@use '@css/variables';

.tabs {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--beigedark);
  padding-left: 1em;

  list-style: none;
  gap: .5em;
  margin: 0;

  &.light {

    border-bottom: 0 none;
    justify-content: flex-end;
    margin-right: 2em;

    button {
      color: var(--font-color);

    }

    .tab.tabActive button {
      background-color: var(--beige);
      color: var(--beigedarker);
    }
  }
}

.tab {

  button {
    background-color: transparent;
    color: var(--beigedarker);
    height: 100%;
    padding: .25em 1em;

    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 0 none;
  }

  &.tabActive button {
    background-color: var(--beigedarker);
    color: var(--beige);

  }
}

@media only screen and (min-width: variables.$sm-breakpoint) {
  .tab {

    button {
      padding: 0.5rem 0.75rem;
    }
  }
}